export const userRoles = {
  admin: 'admin',
  supplier: 'supplier',
  trainer: 'trainer',
  serivce : 'serivce'

};
